// App.js
import React, { useState, useEffect } from "react";
import Toast from "react-native-toast-message";
import { NavigationContainer } from "@react-navigation/native";
import { createStackNavigator } from "@react-navigation/stack";
import LoadingPage from "./components/LoadingPage";
// import LoginPage from "./components/LoginPage";
import LoginPage from "./screens/Login";
// import HomePage from "./components/HomePage";
import HomePage from "./screens/Home";
import QRCodeScannerPage from "./components/QRCodeScannerPage";
import ViewRequestPage from "./components/ViewRequestPage";
import { useTranslation } from "react-i18next";

import { NativeWindStyleSheet } from "nativewind";
import { SafeAreaProvider, SafeAreaView } from "react-native-safe-area-context";

NativeWindStyleSheet.setOutput({
  default: "native",
});

const Stack = createStackNavigator();

const App = () => {
  const { t } = useTranslation();
  return (
    <SafeAreaProvider>
      <NavigationContainer>
        <Stack.Navigator initialRouteName="Loading">
          <Stack.Screen
            name="Loading"
            component={LoadingPage}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name="Login"
            component={LoginPage}
            options={{
              headerLeft: null,
              headerTitle: "PatientCompanion",
            }}
          />
          <Stack.Screen
            name="Home"
            component={HomePage}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name="QRCodeScanner"
            component={QRCodeScannerPage}
            options={{ headerTitle: "PatientCompanion" }}
          />
          <Stack.Screen
            name="ViewRequests"
            component={ViewRequestPage}
            options={{ headerTitle: t("View My Requests") }}
          />
        </Stack.Navigator>
        <Toast ref={(ref) => Toast.setRef(ref)} />
      </NavigationContainer>
    </SafeAreaProvider>
  );
};

export default App;
